"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _VideoConferenceAPI = require("crm_data/extensions/videoConference/VideoConferenceAPI");

var _ActionNamespaces = require("crm_data/actions/ActionNamespaces");

var _LazyValueStore = require("crm_data/store/LazyValueStore");

var _dispatcher = _interopRequireDefault(require("dispatcher/dispatcher"));

var VideoConferenceStore = (0, _LazyValueStore.defineLazyValueStore)({
  namespace: _ActionNamespaces.VIDEO_CONFERENCE,
  fetch: _VideoConferenceAPI.getAvailableVideoConferenceExtensions
}).defineName('VideoConferenceStore').register(_dispatcher.default);
var _default = VideoConferenceStore;
exports.default = _default;
module.exports = exports.default;